// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file message/message_responses.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type {
  ChatError_ArticleIsNotAllowed,
  ChatError_ChatIsUnavailable,
  ChatError_HasNoPermissionsToPerformAction,
  ChatError_NoPermissionsToDeleteMessage,
  ChatError_NoPermissionsToSendMessage,
  ChatError_UnsupportedChatType,
  ChatError_UserChatRelationshipDoesNotExist,
} from '../chat/chat_errors_pb';
import { file_chat_chat_errors } from '../chat/chat_errors_pb';
import type { MissingParamsError, TooManyDataError } from '../common/common_errors_pb';
import { file_common_common_errors } from '../common/common_errors_pb';
import type { LinkPreview, Range } from '../common/common_model_pb';
import { file_common_common_model } from '../common/common_model_pb';
import type { BooleanResponse } from '../common/common_responses_pb';
import { file_common_common_responses } from '../common/common_responses_pb';
import type {
  MessageError_E2eeCommitSyncRequired,
  MessageError_HasNoPermissionsToUpdateMessage,
  MessageError_MaxAlbumItemsLimitReached,
  MessageError_MessageDoesNotExist,
  MessageError_QuotedMessageIsNotExist,
  MessageError_ReactOnSystemMessageIsForbidden,
  MessageError_UnableToCreateLinkPreview,
} from './message_errors_pb';
import { file_message_message_errors } from './message_errors_pb';
import type { Message as Message$1, MessageCountData, ScheduledMessage } from './message_model_pb';
import { file_message_message_model } from './message_model_pb';

/**
 * Describes the file message/message_responses.proto.
 */
export const file_message_message_responses: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [
      file_message_message_model,
      file_chat_chat_errors,
      file_common_common_responses,
      file_common_common_errors,
      file_common_common_model,
      file_message_message_errors,
    ]
  );

/**
 * @generated from message com.gem.bff.contract.GetMessagesResponse
 */
export type GetMessagesResponse = Message<'com.gem.bff.contract.GetMessagesResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.GetMessagesResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetMessagesSuccess success = 1;
         */
        value: GetMessagesSuccess;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 2;
         */
        value: ChatError_ChatIsUnavailable;
        case: 'chatIsUnavailable';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.UserChatRelationshipDoesNotExist userChatRelationshipDoesNotExist = 3;
         */
        value: ChatError_UserChatRelationshipDoesNotExist;
        case: 'userChatRelationshipDoesNotExist';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.GetMessagesResponse.
 * Use `create(GetMessagesResponseSchema)` to create a new message.
 */
export const GetMessagesResponseSchema: GenMessage<GetMessagesResponse> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 0);

/**
 * @generated from message com.gem.bff.contract.GetMessagesByMediaTypesResponse
 */
export type GetMessagesByMediaTypesResponse =
  Message<'com.gem.bff.contract.GetMessagesByMediaTypesResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.GetMessagesByMediaTypesResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.GetMessagesSuccess success = 1;
           */
          value: GetMessagesSuccess;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 2;
           */
          value: ChatError_ChatIsUnavailable;
          case: 'chatIsUnavailable';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.UserChatRelationshipDoesNotExist userChatRelationshipDoesNotExist = 3;
           */
          value: ChatError_UserChatRelationshipDoesNotExist;
          case: 'userChatRelationshipDoesNotExist';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.GetMessagesByMediaTypesResponse.
 * Use `create(GetMessagesByMediaTypesResponseSchema)` to create a new message.
 */
export const GetMessagesByMediaTypesResponseSchema: GenMessage<GetMessagesByMediaTypesResponse> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 1);

/**
 * @generated from message com.gem.bff.contract.GetMessagesSuccess
 */
export type GetMessagesSuccess = Message<'com.gem.bff.contract.GetMessagesSuccess'> & {
  /**
   * @generated from field: optional int64 cursorTs = 1;
   */
  cursorTs?: bigint;

  /**
   * @generated from field: repeated com.gem.bff.contract.Message items = 2;
   */
  items: Message$1[];

  /**
   * @generated from field: optional int64 maxTs = 3;
   */
  maxTs?: bigint;

  /**
   * @generated from field: optional int64 minTs = 4;
   */
  minTs?: bigint;
};

/**
 * Describes the message com.gem.bff.contract.GetMessagesSuccess.
 * Use `create(GetMessagesSuccessSchema)` to create a new message.
 */
export const GetMessagesSuccessSchema: GenMessage<GetMessagesSuccess> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 2);

/**
 * @generated from message com.gem.bff.contract.UpdateMessageResponse
 */
export type UpdateMessageResponse = Message<'com.gem.bff.contract.UpdateMessageResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.UpdateMessageResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.UpdateMessageSuccess success = 1;
         */
        value: UpdateMessageSuccess;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 2;
         */
        value: ChatError_ChatIsUnavailable;
        case: 'chatIsUnavailable';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.UserChatRelationshipDoesNotExist userChatRelationshipDoesNotExist = 3;
         */
        value: ChatError_UserChatRelationshipDoesNotExist;
        case: 'userChatRelationshipDoesNotExist';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.NoPermissionsToSendMessage noPermissionsToSendMessage = 4;
         */
        value: ChatError_NoPermissionsToSendMessage;
        case: 'noPermissionsToSendMessage';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.MessageError.MessageDoesNotExist messageDoesNotExist = 5;
         */
        value: MessageError_MessageDoesNotExist;
        case: 'messageDoesNotExist';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.MessageError.HasNoPermissionsToUpdateMessage hasNoPermissionsToUpdateMessage = 6;
         */
        value: MessageError_HasNoPermissionsToUpdateMessage;
        case: 'hasNoPermissionsToUpdateMessage';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.UpdateMessageResponse.
 * Use `create(UpdateMessageResponseSchema)` to create a new message.
 */
export const UpdateMessageResponseSchema: GenMessage<UpdateMessageResponse> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 3);

/**
 * @generated from message com.gem.bff.contract.UpdateMessageSuccess
 */
export type UpdateMessageSuccess = Message<'com.gem.bff.contract.UpdateMessageSuccess'> & {
  /**
   * @generated from field: com.gem.bff.contract.Message message = 1;
   */
  message?: Message$1;
};

/**
 * Describes the message com.gem.bff.contract.UpdateMessageSuccess.
 * Use `create(UpdateMessageSuccessSchema)` to create a new message.
 */
export const UpdateMessageSuccessSchema: GenMessage<UpdateMessageSuccess> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 4);

/**
 * @generated from message com.gem.bff.contract.SendMessageResponse
 */
export type SendMessageResponse = Message<'com.gem.bff.contract.SendMessageResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.SendMessageResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.SendMessageSuccess success = 1;
         */
        value: SendMessageSuccess;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 2;
         */
        value: ChatError_ChatIsUnavailable;
        case: 'chatIsUnavailable';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.UserChatRelationshipDoesNotExist userChatRelationshipDoesNotExist = 3;
         */
        value: ChatError_UserChatRelationshipDoesNotExist;
        case: 'userChatRelationshipDoesNotExist';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.ArticleIsNotAllowed articleIsNotAllowed = 4;
         */
        value: ChatError_ArticleIsNotAllowed;
        case: 'articleIsNotAllowed';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.NoPermissionsToSendMessage noPermissionsToSendMessage = 5;
         */
        value: ChatError_NoPermissionsToSendMessage;
        case: 'noPermissionsToSendMessage';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.MessageError.MaxAlbumItemsLimitReached maxAlbumItemsLimitReached = 6;
         */
        value: MessageError_MaxAlbumItemsLimitReached;
        case: 'maxAlbumItemsLimitReached';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.MessageError.QuotedMessageIsNotExist quotedMessageIsNotExist = 7;
         */
        value: MessageError_QuotedMessageIsNotExist;
        case: 'quotedMessageIsNotExist';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.MessageError.E2eeCommitSyncRequired e2eeCommitSyncRequired = 8;
         */
        value: MessageError_E2eeCommitSyncRequired;
        case: 'e2eeCommitSyncRequired';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.SendMessageResponse.
 * Use `create(SendMessageResponseSchema)` to create a new message.
 */
export const SendMessageResponseSchema: GenMessage<SendMessageResponse> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 5);

/**
 * @generated from message com.gem.bff.contract.SendMessageSuccess
 */
export type SendMessageSuccess = Message<'com.gem.bff.contract.SendMessageSuccess'> & {
  /**
   * @generated from field: com.gem.bff.contract.Message message = 1;
   */
  message?: Message$1;

  /**
   * @generated from field: int64 previousMessageTs = 2;
   */
  previousMessageTs: bigint;
};

/**
 * Describes the message com.gem.bff.contract.SendMessageSuccess.
 * Use `create(SendMessageSuccessSchema)` to create a new message.
 */
export const SendMessageSuccessSchema: GenMessage<SendMessageSuccess> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 6);

/**
 * @generated from message com.gem.bff.contract.GetRangeAroundMessageResponse
 */
export type GetRangeAroundMessageResponse =
  Message<'com.gem.bff.contract.GetRangeAroundMessageResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.GetRangeAroundMessageResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.GetRangeAroundMessageSuccess success = 1;
           */
          value: GetRangeAroundMessageSuccess;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 2;
           */
          value: ChatError_ChatIsUnavailable;
          case: 'chatIsUnavailable';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.UserChatRelationshipDoesNotExist userChatRelationshipDoesNotExist = 3;
           */
          value: ChatError_UserChatRelationshipDoesNotExist;
          case: 'userChatRelationshipDoesNotExist';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.MessageError.MessageDoesNotExist messageDoesNotExist = 4;
           */
          value: MessageError_MessageDoesNotExist;
          case: 'messageDoesNotExist';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.GetRangeAroundMessageResponse.
 * Use `create(GetRangeAroundMessageResponseSchema)` to create a new message.
 */
export const GetRangeAroundMessageResponseSchema: GenMessage<GetRangeAroundMessageResponse> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 7);

/**
 * @generated from message com.gem.bff.contract.GetRangeAroundMessageSuccess
 */
export type GetRangeAroundMessageSuccess =
  Message<'com.gem.bff.contract.GetRangeAroundMessageSuccess'> & {
    /**
     * @generated from field: repeated com.gem.bff.contract.Message items = 1;
     */
    items: Message$1[];

    /**
     * @generated from field: optional int64 maxTs = 3;
     */
    maxTs?: bigint;

    /**
     * @generated from field: optional int64 minTs = 4;
     */
    minTs?: bigint;
  };

/**
 * Describes the message com.gem.bff.contract.GetRangeAroundMessageSuccess.
 * Use `create(GetRangeAroundMessageSuccessSchema)` to create a new message.
 */
export const GetRangeAroundMessageSuccessSchema: GenMessage<GetRangeAroundMessageSuccess> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 8);

/**
 * @generated from message com.gem.bff.contract.GetMessagesByIdsResponse
 */
export type GetMessagesByIdsResponse = Message<'com.gem.bff.contract.GetMessagesByIdsResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.GetMessagesByIdsResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetMessagesByIdsSuccess success = 1;
         */
        value: GetMessagesByIdsSuccess;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 2;
         */
        value: ChatError_ChatIsUnavailable;
        case: 'chatIsUnavailable';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.UserChatRelationshipDoesNotExist userChatRelationshipDoesNotExist = 3;
         */
        value: ChatError_UserChatRelationshipDoesNotExist;
        case: 'userChatRelationshipDoesNotExist';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.GetMessagesByIdsResponse.
 * Use `create(GetMessagesByIdsResponseSchema)` to create a new message.
 */
export const GetMessagesByIdsResponseSchema: GenMessage<GetMessagesByIdsResponse> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 9);

/**
 * @generated from message com.gem.bff.contract.GetMessagesByIdsSuccess
 */
export type GetMessagesByIdsSuccess = Message<'com.gem.bff.contract.GetMessagesByIdsSuccess'> & {
  /**
   * @generated from field: repeated com.gem.bff.contract.Message items = 1;
   */
  items: Message$1[];
};

/**
 * Describes the message com.gem.bff.contract.GetMessagesByIdsSuccess.
 * Use `create(GetMessagesByIdsSuccessSchema)` to create a new message.
 */
export const GetMessagesByIdsSuccessSchema: GenMessage<GetMessagesByIdsSuccess> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 10);

/**
 * @generated from message com.gem.bff.contract.GetMessagesAroundTsResponse
 */
export type GetMessagesAroundTsResponse =
  Message<'com.gem.bff.contract.GetMessagesAroundTsResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.GetMessagesAroundTsResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.GetMessagesAroundTsSuccess success = 1;
           */
          value: GetMessagesAroundTsSuccess;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 2;
           */
          value: ChatError_ChatIsUnavailable;
          case: 'chatIsUnavailable';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.UserChatRelationshipDoesNotExist userChatRelationshipDoesNotExist = 3;
           */
          value: ChatError_UserChatRelationshipDoesNotExist;
          case: 'userChatRelationshipDoesNotExist';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.GetMessagesAroundTsResponse.
 * Use `create(GetMessagesAroundTsResponseSchema)` to create a new message.
 */
export const GetMessagesAroundTsResponseSchema: GenMessage<GetMessagesAroundTsResponse> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 11);

/**
 * @generated from message com.gem.bff.contract.GetMessagesAroundTsSuccess
 */
export type GetMessagesAroundTsSuccess =
  Message<'com.gem.bff.contract.GetMessagesAroundTsSuccess'> & {
    /**
     * @generated from field: repeated com.gem.bff.contract.Message items = 1;
     */
    items: Message$1[];

    /**
     * @generated from field: optional int64 maxTs = 2;
     */
    maxTs?: bigint;

    /**
     * @generated from field: optional int64 minTs = 3;
     */
    minTs?: bigint;
  };

/**
 * Describes the message com.gem.bff.contract.GetMessagesAroundTsSuccess.
 * Use `create(GetMessagesAroundTsSuccessSchema)` to create a new message.
 */
export const GetMessagesAroundTsSuccessSchema: GenMessage<GetMessagesAroundTsSuccess> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 12);

/**
 * @generated from message com.gem.bff.contract.GetRangeAroundNextUserMentionResponse
 */
export type GetRangeAroundNextUserMentionResponse =
  Message<'com.gem.bff.contract.GetRangeAroundNextUserMentionResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.GetRangeAroundNextUserMentionResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.GetRangeAroundNextUserMentionSuccess success = 1;
           */
          value: GetRangeAroundNextUserMentionSuccess;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 2;
           */
          value: ChatError_ChatIsUnavailable;
          case: 'chatIsUnavailable';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.UserChatRelationshipDoesNotExist userChatRelationshipDoesNotExist = 3;
           */
          value: ChatError_UserChatRelationshipDoesNotExist;
          case: 'userChatRelationshipDoesNotExist';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.UnsupportedChatType unsupportedChatType = 4;
           */
          value: ChatError_UnsupportedChatType;
          case: 'unsupportedChatType';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.MessageError.MessageDoesNotExist messageDoesNotExist = 5;
           */
          value: MessageError_MessageDoesNotExist;
          case: 'messageDoesNotExist';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.GetRangeAroundNextUserMentionResponse.
 * Use `create(GetRangeAroundNextUserMentionResponseSchema)` to create a new message.
 */
export const GetRangeAroundNextUserMentionResponseSchema: GenMessage<GetRangeAroundNextUserMentionResponse> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 13);

/**
 * @generated from message com.gem.bff.contract.GetRangeAroundNextUserMentionSuccess
 */
export type GetRangeAroundNextUserMentionSuccess =
  Message<'com.gem.bff.contract.GetRangeAroundNextUserMentionSuccess'> & {
    /**
     * @generated from field: repeated com.gem.bff.contract.Message items = 1;
     */
    items: Message$1[];
  };

/**
 * Describes the message com.gem.bff.contract.GetRangeAroundNextUserMentionSuccess.
 * Use `create(GetRangeAroundNextUserMentionSuccessSchema)` to create a new message.
 */
export const GetRangeAroundNextUserMentionSuccessSchema: GenMessage<GetRangeAroundNextUserMentionSuccess> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 14);

/**
 * @generated from message com.gem.bff.contract.GetUsersReactionsForMessageResponse
 */
export type GetUsersReactionsForMessageResponse =
  Message<'com.gem.bff.contract.GetUsersReactionsForMessageResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.GetUsersReactionsForMessageResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.GetUsersReactionsForMessageSuccess success = 1;
           */
          value: GetUsersReactionsForMessageSuccess;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 2;
           */
          value: ChatError_ChatIsUnavailable;
          case: 'chatIsUnavailable';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.UserChatRelationshipDoesNotExist userChatRelationshipDoesNotExist = 3;
           */
          value: ChatError_UserChatRelationshipDoesNotExist;
          case: 'userChatRelationshipDoesNotExist';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.HasNoPermissionsToPerformAction hasNoPermissionsToPerformAction = 4;
           */
          value: ChatError_HasNoPermissionsToPerformAction;
          case: 'hasNoPermissionsToPerformAction';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.MessageError.MessageDoesNotExist messageDoesNotExist = 5;
           */
          value: MessageError_MessageDoesNotExist;
          case: 'messageDoesNotExist';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.GetUsersReactionsForMessageResponse.
 * Use `create(GetUsersReactionsForMessageResponseSchema)` to create a new message.
 */
export const GetUsersReactionsForMessageResponseSchema: GenMessage<GetUsersReactionsForMessageResponse> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 15);

/**
 * @generated from message com.gem.bff.contract.GetUsersReactionsForMessageSuccess
 */
export type GetUsersReactionsForMessageSuccess =
  Message<'com.gem.bff.contract.GetUsersReactionsForMessageSuccess'> & {
    /**
     * @generated from field: repeated com.gem.bff.contract.GetUsersReactionsForMessageSuccess.ReactionEntry usersReactions = 1;
     */
    usersReactions: GetUsersReactionsForMessageSuccess_ReactionEntry[];
  };

/**
 * Describes the message com.gem.bff.contract.GetUsersReactionsForMessageSuccess.
 * Use `create(GetUsersReactionsForMessageSuccessSchema)` to create a new message.
 */
export const GetUsersReactionsForMessageSuccessSchema: GenMessage<GetUsersReactionsForMessageSuccess> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 16);

/**
 * @generated from message com.gem.bff.contract.GetUsersReactionsForMessageSuccess.ReactionEntry
 */
export type GetUsersReactionsForMessageSuccess_ReactionEntry =
  Message<'com.gem.bff.contract.GetUsersReactionsForMessageSuccess.ReactionEntry'> & {
    /**
     * @generated from field: int64 reactionId = 1;
     */
    reactionId: bigint;

    /**
     * @generated from field: repeated int64 userIds = 2;
     */
    userIds: bigint[];
  };

/**
 * Describes the message com.gem.bff.contract.GetUsersReactionsForMessageSuccess.ReactionEntry.
 * Use `create(GetUsersReactionsForMessageSuccess_ReactionEntrySchema)` to create a new message.
 */
export const GetUsersReactionsForMessageSuccess_ReactionEntrySchema: GenMessage<GetUsersReactionsForMessageSuccess_ReactionEntry> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 16, 0);

/**
 * @generated from message com.gem.bff.contract.AddMessageReactionResponse
 */
export type AddMessageReactionResponse =
  Message<'com.gem.bff.contract.AddMessageReactionResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.AddMessageReactionResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.AddMessageReactionSuccess success = 1;
           */
          value: AddMessageReactionSuccess;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 2;
           */
          value: ChatError_ChatIsUnavailable;
          case: 'chatIsUnavailable';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.UserChatRelationshipDoesNotExist userChatRelationshipDoesNotExist = 3;
           */
          value: ChatError_UserChatRelationshipDoesNotExist;
          case: 'userChatRelationshipDoesNotExist';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.HasNoPermissionsToPerformAction hasNoPermissionsToPerformAction = 4;
           */
          value: ChatError_HasNoPermissionsToPerformAction;
          case: 'hasNoPermissionsToPerformAction';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.MessageError.ReactOnSystemMessageIsForbidden reactOnSystemMessageIsForbidden = 5;
           */
          value: MessageError_ReactOnSystemMessageIsForbidden;
          case: 'reactOnSystemMessageIsForbidden';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.MessageError.MessageDoesNotExist messageDoesNotExist = 6;
           */
          value: MessageError_MessageDoesNotExist;
          case: 'messageDoesNotExist';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.AddMessageReactionResponse.
 * Use `create(AddMessageReactionResponseSchema)` to create a new message.
 */
export const AddMessageReactionResponseSchema: GenMessage<AddMessageReactionResponse> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 17);

/**
 * @generated from message com.gem.bff.contract.AddMessageReactionSuccess
 */
export type AddMessageReactionSuccess =
  Message<'com.gem.bff.contract.AddMessageReactionSuccess'> & {
    /**
     * @generated from field: com.gem.bff.contract.Message message = 1;
     */
    message?: Message$1;
  };

/**
 * Describes the message com.gem.bff.contract.AddMessageReactionSuccess.
 * Use `create(AddMessageReactionSuccessSchema)` to create a new message.
 */
export const AddMessageReactionSuccessSchema: GenMessage<AddMessageReactionSuccess> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 18);

/**
 * @generated from message com.gem.bff.contract.RemoveMessageReactionResponse
 */
export type RemoveMessageReactionResponse =
  Message<'com.gem.bff.contract.RemoveMessageReactionResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.RemoveMessageReactionResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.RemoveMessageReactionSuccess success = 1;
           */
          value: RemoveMessageReactionSuccess;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 2;
           */
          value: ChatError_ChatIsUnavailable;
          case: 'chatIsUnavailable';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.UserChatRelationshipDoesNotExist userChatRelationshipDoesNotExist = 3;
           */
          value: ChatError_UserChatRelationshipDoesNotExist;
          case: 'userChatRelationshipDoesNotExist';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.HasNoPermissionsToPerformAction hasNoPermissionsToPerformAction = 4;
           */
          value: ChatError_HasNoPermissionsToPerformAction;
          case: 'hasNoPermissionsToPerformAction';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.MessageError.ReactOnSystemMessageIsForbidden reactOnSystemMessageIsForbidden = 5;
           */
          value: MessageError_ReactOnSystemMessageIsForbidden;
          case: 'reactOnSystemMessageIsForbidden';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.MessageError.MessageDoesNotExist messageDoesNotExist = 6;
           */
          value: MessageError_MessageDoesNotExist;
          case: 'messageDoesNotExist';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.RemoveMessageReactionResponse.
 * Use `create(RemoveMessageReactionResponseSchema)` to create a new message.
 */
export const RemoveMessageReactionResponseSchema: GenMessage<RemoveMessageReactionResponse> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 19);

/**
 * @generated from message com.gem.bff.contract.RemoveMessageReactionSuccess
 */
export type RemoveMessageReactionSuccess =
  Message<'com.gem.bff.contract.RemoveMessageReactionSuccess'> & {
    /**
     * @generated from field: com.gem.bff.contract.Message message = 1;
     */
    message?: Message$1;
  };

/**
 * Describes the message com.gem.bff.contract.RemoveMessageReactionSuccess.
 * Use `create(RemoveMessageReactionSuccessSchema)` to create a new message.
 */
export const RemoveMessageReactionSuccessSchema: GenMessage<RemoveMessageReactionSuccess> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 20);

/**
 * @generated from message com.gem.bff.contract.IncreaseViewsResponse
 */
export type IncreaseViewsResponse = Message<'com.gem.bff.contract.IncreaseViewsResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.IncreaseViewsResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
         */
        value: BooleanResponse;
        case: 'success';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.IncreaseViewsResponse.
 * Use `create(IncreaseViewsResponseSchema)` to create a new message.
 */
export const IncreaseViewsResponseSchema: GenMessage<IncreaseViewsResponse> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 21);

/**
 * @generated from message com.gem.bff.contract.GetUsersViewedMessageResponse
 */
export type GetUsersViewedMessageResponse =
  Message<'com.gem.bff.contract.GetUsersViewedMessageResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.GetUsersViewedMessageResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.GetUsersViewedMessageSuccess success = 1;
           */
          value: GetUsersViewedMessageSuccess;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 2;
           */
          value: ChatError_ChatIsUnavailable;
          case: 'chatIsUnavailable';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.UserChatRelationshipDoesNotExist userChatRelationshipDoesNotExist = 3;
           */
          value: ChatError_UserChatRelationshipDoesNotExist;
          case: 'userChatRelationshipDoesNotExist';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.HasNoPermissionsToPerformAction hasNoPermissionsToPerformAction = 4;
           */
          value: ChatError_HasNoPermissionsToPerformAction;
          case: 'hasNoPermissionsToPerformAction';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.GetUsersViewedMessageResponse.
 * Use `create(GetUsersViewedMessageResponseSchema)` to create a new message.
 */
export const GetUsersViewedMessageResponseSchema: GenMessage<GetUsersViewedMessageResponse> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 22);

/**
 * @generated from message com.gem.bff.contract.GetUsersViewedMessageSuccess
 */
export type GetUsersViewedMessageSuccess =
  Message<'com.gem.bff.contract.GetUsersViewedMessageSuccess'> & {
    /**
     * @generated from field: repeated int64 userIds = 1;
     */
    userIds: bigint[];

    /**
     * @generated from field: optional string cursor = 2;
     */
    cursor?: string;
  };

/**
 * Describes the message com.gem.bff.contract.GetUsersViewedMessageSuccess.
 * Use `create(GetUsersViewedMessageSuccessSchema)` to create a new message.
 */
export const GetUsersViewedMessageSuccessSchema: GenMessage<GetUsersViewedMessageSuccess> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 23);

/**
 * @generated from message com.gem.bff.contract.ForwardMessagesResponse
 */
export type ForwardMessagesResponse = Message<'com.gem.bff.contract.ForwardMessagesResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.ForwardMessagesResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.ForwardMessagesSuccess success = 1;
         */
        value: ForwardMessagesSuccess;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.MissingParamsError missingParamsError = 2;
         */
        value: MissingParamsError;
        case: 'missingParamsError';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.TooManyDataError tooManyDataError = 3;
         */
        value: TooManyDataError;
        case: 'tooManyDataError';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 4;
         */
        value: ChatError_ChatIsUnavailable;
        case: 'chatIsUnavailable';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.UserChatRelationshipDoesNotExist userChatRelationshipDoesNotExist = 5;
         */
        value: ChatError_UserChatRelationshipDoesNotExist;
        case: 'userChatRelationshipDoesNotExist';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.NoPermissionsToSendMessage noPermissionsToSendMessage = 6;
         */
        value: ChatError_NoPermissionsToSendMessage;
        case: 'noPermissionsToSendMessage';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.ForwardMessagesResponse.
 * Use `create(ForwardMessagesResponseSchema)` to create a new message.
 */
export const ForwardMessagesResponseSchema: GenMessage<ForwardMessagesResponse> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 24);

/**
 * @generated from message com.gem.bff.contract.ForwardMessagesSuccess
 */
export type ForwardMessagesSuccess = Message<'com.gem.bff.contract.ForwardMessagesSuccess'> & {
  /**
   * @generated from field: repeated com.gem.bff.contract.ForwardMessagesSuccess.Metadata items = 1;
   */
  items: ForwardMessagesSuccess_Metadata[];

  /**
   * @generated from field: repeated int64 unavailableChatIds = 2;
   */
  unavailableChatIds: bigint[];

  /**
   * @generated from field: repeated int64 unavailableContactIds = 3;
   */
  unavailableContactIds: bigint[];
};

/**
 * Describes the message com.gem.bff.contract.ForwardMessagesSuccess.
 * Use `create(ForwardMessagesSuccessSchema)` to create a new message.
 */
export const ForwardMessagesSuccessSchema: GenMessage<ForwardMessagesSuccess> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 25);

/**
 * @generated from message com.gem.bff.contract.ForwardMessagesSuccess.Metadata
 */
export type ForwardMessagesSuccess_Metadata =
  Message<'com.gem.bff.contract.ForwardMessagesSuccess.Metadata'> & {
    /**
     * @generated from field: int64 chatId = 1;
     */
    chatId: bigint;

    /**
     * @generated from field: repeated com.gem.bff.contract.Message items = 2;
     */
    items: Message$1[];

    /**
     * @generated from field: int64 previousMessageTs = 3;
     */
    previousMessageTs: bigint;
  };

/**
 * Describes the message com.gem.bff.contract.ForwardMessagesSuccess.Metadata.
 * Use `create(ForwardMessagesSuccess_MetadataSchema)` to create a new message.
 */
export const ForwardMessagesSuccess_MetadataSchema: GenMessage<ForwardMessagesSuccess_Metadata> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 25, 0);

/**
 * @generated from message com.gem.bff.contract.DeleteMessagesResponse
 */
export type DeleteMessagesResponse = Message<'com.gem.bff.contract.DeleteMessagesResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.DeleteMessagesResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
         */
        value: BooleanResponse;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.MissingParamsError missingParams = 2;
         */
        value: MissingParamsError;
        case: 'missingParams';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 3;
         */
        value: ChatError_ChatIsUnavailable;
        case: 'chatIsUnavailable';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.NoPermissionsToDeleteMessage noPermissionsToDeleteMessage = 4;
         */
        value: ChatError_NoPermissionsToDeleteMessage;
        case: 'noPermissionsToDeleteMessage';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.DeleteMessagesResponse.
 * Use `create(DeleteMessagesResponseSchema)` to create a new message.
 */
export const DeleteMessagesResponseSchema: GenMessage<DeleteMessagesResponse> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 26);

/**
 * @generated from message com.gem.bff.contract.SearchMessagesResponse
 */
export type SearchMessagesResponse = Message<'com.gem.bff.contract.SearchMessagesResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.SearchMessagesResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.SearchMessagesSuccess success = 1;
         */
        value: SearchMessagesSuccess;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 2;
         */
        value: ChatError_ChatIsUnavailable;
        case: 'chatIsUnavailable';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.UserChatRelationshipDoesNotExist userChatRelationshipDoesNotExist = 3;
         */
        value: ChatError_UserChatRelationshipDoesNotExist;
        case: 'userChatRelationshipDoesNotExist';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.HasNoPermissionsToPerformAction hasNoPermissionsToPerformAction = 4;
         */
        value: ChatError_HasNoPermissionsToPerformAction;
        case: 'hasNoPermissionsToPerformAction';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.SearchMessagesResponse.
 * Use `create(SearchMessagesResponseSchema)` to create a new message.
 */
export const SearchMessagesResponseSchema: GenMessage<SearchMessagesResponse> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 27);

/**
 * @generated from message com.gem.bff.contract.SearchMessagesSuccess
 */
export type SearchMessagesSuccess = Message<'com.gem.bff.contract.SearchMessagesSuccess'> & {
  /**
   * @generated from field: repeated com.gem.bff.contract.SearchMessageResult results = 1;
   */
  results: SearchMessageResult[];

  /**
   * @generated from field: optional string cursor = 2;
   */
  cursor?: string;

  /**
   * @generated from field: int32 count = 3;
   */
  count: number;
};

/**
 * Describes the message com.gem.bff.contract.SearchMessagesSuccess.
 * Use `create(SearchMessagesSuccessSchema)` to create a new message.
 */
export const SearchMessagesSuccessSchema: GenMessage<SearchMessagesSuccess> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 28);

/**
 * @generated from message com.gem.bff.contract.SearchMessageResult
 */
export type SearchMessageResult = Message<'com.gem.bff.contract.SearchMessageResult'> & {
  /**
   * @generated from field: com.gem.bff.contract.Message message = 1;
   */
  message?: Message$1;

  /**
   * @generated from field: repeated com.gem.bff.contract.Range highlights = 2;
   */
  highlights: Range[];

  /**
   * Only for test purpose. Clients don't use this field.
   *
   * @generated from field: string content = 3;
   */
  content: string;
};

/**
 * Describes the message com.gem.bff.contract.SearchMessageResult.
 * Use `create(SearchMessageResultSchema)` to create a new message.
 */
export const SearchMessageResultSchema: GenMessage<SearchMessageResult> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 29);

/**
 * @generated from message com.gem.bff.contract.GetLinkPreviewResponse
 */
export type GetLinkPreviewResponse = Message<'com.gem.bff.contract.GetLinkPreviewResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.GetLinkPreviewResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetLinkPreviewSuccess success = 1;
         */
        value: GetLinkPreviewSuccess;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.MessageError.UnableToCreateLinkPreview unableToCreateLinkPreview = 2;
         */
        value: MessageError_UnableToCreateLinkPreview;
        case: 'unableToCreateLinkPreview';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.GetLinkPreviewResponse.
 * Use `create(GetLinkPreviewResponseSchema)` to create a new message.
 */
export const GetLinkPreviewResponseSchema: GenMessage<GetLinkPreviewResponse> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 30);

/**
 * @generated from message com.gem.bff.contract.GetLinkPreviewSuccess
 */
export type GetLinkPreviewSuccess = Message<'com.gem.bff.contract.GetLinkPreviewSuccess'> & {
  /**
   * @generated from field: com.gem.bff.contract.LinkPreview linkPreview = 1;
   */
  linkPreview?: LinkPreview;
};

/**
 * Describes the message com.gem.bff.contract.GetLinkPreviewSuccess.
 * Use `create(GetLinkPreviewSuccessSchema)` to create a new message.
 */
export const GetLinkPreviewSuccessSchema: GenMessage<GetLinkPreviewSuccess> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 31);

/**
 * @generated from message com.gem.bff.contract.GetMessagesCountsResponse
 */
export type GetMessagesCountsResponse =
  Message<'com.gem.bff.contract.GetMessagesCountsResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.GetMessagesCountsResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.GetMessagesCountsSuccess success = 1;
           */
          value: GetMessagesCountsSuccess;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 2;
           */
          value: ChatError_ChatIsUnavailable;
          case: 'chatIsUnavailable';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.UserChatRelationshipDoesNotExist userChatRelationshipDoesNotExist = 3;
           */
          value: ChatError_UserChatRelationshipDoesNotExist;
          case: 'userChatRelationshipDoesNotExist';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.GetMessagesCountsResponse.
 * Use `create(GetMessagesCountsResponseSchema)` to create a new message.
 */
export const GetMessagesCountsResponseSchema: GenMessage<GetMessagesCountsResponse> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 32);

/**
 * @generated from message com.gem.bff.contract.GetMessagesCountsSuccess
 */
export type GetMessagesCountsSuccess = Message<'com.gem.bff.contract.GetMessagesCountsSuccess'> & {
  /**
   * @generated from field: repeated com.gem.bff.contract.MessageCountData counts = 1;
   */
  counts: MessageCountData[];
};

/**
 * Describes the message com.gem.bff.contract.GetMessagesCountsSuccess.
 * Use `create(GetMessagesCountsSuccessSchema)` to create a new message.
 */
export const GetMessagesCountsSuccessSchema: GenMessage<GetMessagesCountsSuccess> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 33);

/**
 * @generated from message com.gem.bff.contract.ScheduleMessageResponse
 */
export type ScheduleMessageResponse = Message<'com.gem.bff.contract.ScheduleMessageResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.ScheduleMessageResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.ScheduleMessageSuccess success = 1;
         */
        value: ScheduleMessageSuccess;
        case: 'success';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.ScheduleMessageResponse.
 * Use `create(ScheduleMessageResponseSchema)` to create a new message.
 */
export const ScheduleMessageResponseSchema: GenMessage<ScheduleMessageResponse> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 34);

/**
 * @generated from message com.gem.bff.contract.ScheduleMessageSuccess
 */
export type ScheduleMessageSuccess = Message<'com.gem.bff.contract.ScheduleMessageSuccess'> & {
  /**
   * @generated from field: com.gem.bff.contract.ScheduledMessage scheduledMessage = 1;
   */
  scheduledMessage?: ScheduledMessage;
};

/**
 * Describes the message com.gem.bff.contract.ScheduleMessageSuccess.
 * Use `create(ScheduleMessageSuccessSchema)` to create a new message.
 */
export const ScheduleMessageSuccessSchema: GenMessage<ScheduleMessageSuccess> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 35);

/**
 * @generated from message com.gem.bff.contract.SendScheduledMessageNowResponse
 */
export type SendScheduledMessageNowResponse =
  Message<'com.gem.bff.contract.SendScheduledMessageNowResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.SendScheduledMessageNowResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.SendMessageSuccess success = 1;
           */
          value: SendMessageSuccess;
          case: 'success';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.SendScheduledMessageNowResponse.
 * Use `create(SendScheduledMessageNowResponseSchema)` to create a new message.
 */
export const SendScheduledMessageNowResponseSchema: GenMessage<SendScheduledMessageNowResponse> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 36);

/**
 * @generated from message com.gem.bff.contract.UpdateScheduledMessageResponse
 */
export type UpdateScheduledMessageResponse =
  Message<'com.gem.bff.contract.UpdateScheduledMessageResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.UpdateScheduledMessageResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.UpdateScheduledMessageSuccess success = 1;
           */
          value: UpdateScheduledMessageSuccess;
          case: 'success';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.UpdateScheduledMessageResponse.
 * Use `create(UpdateScheduledMessageResponseSchema)` to create a new message.
 */
export const UpdateScheduledMessageResponseSchema: GenMessage<UpdateScheduledMessageResponse> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 37);

/**
 * @generated from message com.gem.bff.contract.UpdateScheduledMessageSuccess
 */
export type UpdateScheduledMessageSuccess =
  Message<'com.gem.bff.contract.UpdateScheduledMessageSuccess'> & {
    /**
     * @generated from field: com.gem.bff.contract.ScheduledMessage scheduledMessage = 1;
     */
    scheduledMessage?: ScheduledMessage;
  };

/**
 * Describes the message com.gem.bff.contract.UpdateScheduledMessageSuccess.
 * Use `create(UpdateScheduledMessageSuccessSchema)` to create a new message.
 */
export const UpdateScheduledMessageSuccessSchema: GenMessage<UpdateScheduledMessageSuccess> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 38);

/**
 * @generated from message com.gem.bff.contract.DeleteScheduledMessagesResponse
 */
export type DeleteScheduledMessagesResponse =
  Message<'com.gem.bff.contract.DeleteScheduledMessagesResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.DeleteScheduledMessagesResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
           */
          value: BooleanResponse;
          case: 'success';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.DeleteScheduledMessagesResponse.
 * Use `create(DeleteScheduledMessagesResponseSchema)` to create a new message.
 */
export const DeleteScheduledMessagesResponseSchema: GenMessage<DeleteScheduledMessagesResponse> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 39);

/**
 * @generated from message com.gem.bff.contract.GetScheduledMessagesResponse
 */
export type GetScheduledMessagesResponse =
  Message<'com.gem.bff.contract.GetScheduledMessagesResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.GetScheduledMessagesResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.GetScheduledMessagesSuccess success = 1;
           */
          value: GetScheduledMessagesSuccess;
          case: 'success';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.GetScheduledMessagesResponse.
 * Use `create(GetScheduledMessagesResponseSchema)` to create a new message.
 */
export const GetScheduledMessagesResponseSchema: GenMessage<GetScheduledMessagesResponse> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 40);

/**
 * @generated from message com.gem.bff.contract.GetScheduledMessagesSuccess
 */
export type GetScheduledMessagesSuccess =
  Message<'com.gem.bff.contract.GetScheduledMessagesSuccess'> & {
    /**
     * @generated from field: repeated com.gem.bff.contract.ScheduledMessage scheduledMessages = 1;
     */
    scheduledMessages: ScheduledMessage[];

    /**
     * @generated from field: optional string nextCursor = 2;
     */
    nextCursor?: string;
  };

/**
 * Describes the message com.gem.bff.contract.GetScheduledMessagesSuccess.
 * Use `create(GetScheduledMessagesSuccessSchema)` to create a new message.
 */
export const GetScheduledMessagesSuccessSchema: GenMessage<GetScheduledMessagesSuccess> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 41);

/**
 * @generated from message com.gem.bff.contract.GetScheduledMessagesByIdsResponse
 */
export type GetScheduledMessagesByIdsResponse =
  Message<'com.gem.bff.contract.GetScheduledMessagesByIdsResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.GetScheduledMessagesByIdsResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.GetScheduledMessagesByIdsSuccess success = 1;
           */
          value: GetScheduledMessagesByIdsSuccess;
          case: 'success';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.GetScheduledMessagesByIdsResponse.
 * Use `create(GetScheduledMessagesByIdsResponseSchema)` to create a new message.
 */
export const GetScheduledMessagesByIdsResponseSchema: GenMessage<GetScheduledMessagesByIdsResponse> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 42);

/**
 * @generated from message com.gem.bff.contract.GetScheduledMessagesByIdsSuccess
 */
export type GetScheduledMessagesByIdsSuccess =
  Message<'com.gem.bff.contract.GetScheduledMessagesByIdsSuccess'> & {
    /**
     * @generated from field: repeated com.gem.bff.contract.ScheduledMessage scheduledMessages = 1;
     */
    scheduledMessages: ScheduledMessage[];
  };

/**
 * Describes the message com.gem.bff.contract.GetScheduledMessagesByIdsSuccess.
 * Use `create(GetScheduledMessagesByIdsSuccessSchema)` to create a new message.
 */
export const GetScheduledMessagesByIdsSuccessSchema: GenMessage<GetScheduledMessagesByIdsSuccess> =
  /*@__PURE__*/
  messageDesc(file_message_message_responses, 43);
